import React from 'react';
import { Chip } from '@mui/material';
import { LocalOffer as LocalOfferIcon } from '@mui/icons-material';

/**
 * Componente reutilizable para mostrar un chip de descuento aplicado
 * @param {Object} discountApplied - Objeto con información del descuento (discount_percentage, discount_amount, offer_name)
 * @param {Object} discountInfo - Alternativa: objeto con offer_name y discount_text (para CarritoData)
 * @param {String} size - Tamaño del chip: 'small' | 'medium' | 'large'
 * @param {Boolean} showOfferName - Si se debe mostrar el nombre de la oferta en el chip
 * @param {Object} sx - Estilos adicionales opcionales
 */
const DiscountChip = ({ discountApplied, discountInfo, size = 'small', showOfferName = false, sx = {} }) => {
  // Manejar ambos formatos: discountApplied (desde ventas) y discountInfo (desde carrito)
  const discount = discountApplied || discountInfo;
  
  if (!discount) return null;

  // Definir tamaños predefinidos
  const sizes = {
    small: {
      height: 16,
      fontSize: '0.6rem',
      iconSize: 10,
    },
    medium: {
      height: 20,
      fontSize: '0.7rem',
      iconSize: 12,
    },
    large: {
      height: 24,
      fontSize: '0.8rem',
      iconSize: 14,
    }
  };

  const currentSize = sizes[size] || sizes.small;

  // Determinar el texto del descuento
  let discountText;
  if (discountInfo && discountInfo.discount_text) {
    // Formato de CarritoData
    discountText = discountInfo.discount_text;
  } else if (discountApplied) {
    // Formato de ventas
    discountText = discountApplied.discount_percentage 
      ? `-${discountApplied.discount_percentage}%` 
      : `-$${discountApplied.discount_amount}`;
  }

  // Texto del label (con o sin nombre de oferta)
  const label = showOfferName && discount.offer_name
    ? `${discount.offer_name} ${discountText}`
    : discountText;

  return (
    <Chip
      icon={<LocalOfferIcon sx={{ fontSize: currentSize.iconSize }} />}
      label={label}
      size={size === 'large' ? 'medium' : 'small'}
      sx={{
        height: currentSize.height,
        fontSize: currentSize.fontSize,
        background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
        color: 'white',
        fontWeight: 600,
        '& .MuiChip-icon': { 
          fontSize: currentSize.iconSize, 
          marginLeft: '4px',
          color: 'white'
        },
        ...sx
      }}
    />
  );
};

export default DiscountChip;
